import { db } from "@/helpers/firebase";
import { doc, setDoc, serverTimestamp } from "firebase/firestore";
 
/**
 * Updates a user's profile data in Firestore.
 * @param {string} userId - The ID of the user to update.
 * @param {object} dataToUpdate - An object containing the fields to update.
 * @returns {Promise<void>} A promise that resolves when the update is complete.
 */
export const updateUserProfile = async (userId, dataToUpdate) => {
    if (!userId) {
      throw new Error("User ID is required to update profile.");
    }
    if (!dataToUpdate || Object.keys(dataToUpdate).length === 0) {
      console.warn("No data provided for update.");
      return; // Or throw an error if an update must contain data
    }
  
    const userDocRef = doc(db, "users", userId);

  
    try {
      // Add/update a timestamp for when the profile was last modified
      const dataWithTimestamp = {
        ...dataToUpdate,
        lastModified: serverTimestamp()
      };
      await setDoc(userDocRef, dataWithTimestamp, { merge: true });
      //console.log("User profile updated successfully for user:", userId);
    } catch (error) {
      console.error("Error updating user profile:", error);
      throw error; // Re-throw the error to be caught by the calling function
    }
  };